import { getTranslator } from 'shared/i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import { isDateBeforeToday } from '../helpers';
import { PriceDrop, Listing } from '../Listings/Listings.types';
import { ListingResponse } from '../Listings/Listings.types';

const t = getTranslator(searchTranslations);

const lastReducedDateLabel = t('listingCard.lastReduced');
const availableFromLabel = t('listingCard.availableFromLabel');

const getIsImmediatelyAvailable = (availableFrom: string) =>
    availableFrom && isDateBeforeToday(availableFrom);

const getPriceDropProps = (priceDrop: PriceDrop | undefined) => {
    if (!priceDrop) {
        return undefined;
    }

    const { lastPriceChangeDate, percentageChangeLabel } = priceDrop;

    return percentageChangeLabel
        ? {
              percentageChangeLabel,
              lastPriceChangeDate: `${lastReducedDateLabel}: ${lastPriceChangeDate}`
          }
        : undefined;
};

export const formatListings = (listings: ListingResponse[]): Listing[] => {
    const formattedListings = listings.map((listing) => {
        const {
            listingId,
            flag: baseFlag,
            availableFrom,
            priceDrop,
            address,
            branch,
            features,
            highlights,
            image,
            isPremium,
            listingUris,
            numberOfFloorPlans,
            numberOfImages,
            numberOfVideos,
            numberOfViews,
            otherPropertyImages,
            price,
            priceTitle,
            publishedOn,
            publishedOnLabel,
            tags,
            title,
            transports
        } = listing;

        const flag = baseFlag !== 'Under offer' ? baseFlag : null;
        const underOffer = baseFlag === 'Under offer';
        const isImmediatelyAvailable = getIsImmediatelyAvailable(availableFrom);
        const availableFromText = isImmediatelyAvailable
            ? 'immediately'
            : availableFrom;
        const availableFromLabelText = isImmediatelyAvailable
            ? 'Available'
            : availableFromLabel;
        const priceDropValue = getPriceDropProps(priceDrop);

        return {
            listingId,
            flag,
            underOffer,
            availableFrom: availableFromText,
            availableFromLabel: availableFromLabelText,
            priceDrop: priceDropValue,
            address,
            branch,
            features,
            highlights,
            image,
            isPremium,
            listingUris,
            numberOfFloorPlans,
            numberOfImages,
            numberOfVideos,
            numberOfViews,
            otherPropertyImages,
            price,
            priceTitle,
            publishedOn,
            publishedOnLabel,
            tags,
            title,
            transports
        };
    });

    return formattedListings;
};
